export { UIPureComponent } from './UIPureComponent';
